var map = {
	"./": 304,
	"./UserSettings": 1135,
	"./UserSettings.dictionary": 339,
	"./UserSettings.dictionary.json": 339,
	"./UserSettings.tsx": 1135,
	"./UserSettingsDeferred": 361,
	"./UserSettingsDeferred.tsx": 361,
	"./components/ChangeButton": 976,
	"./components/ChangeButton/": 976,
	"./components/ChangeButton/ChangeButton.module.scss": 1063,
	"./components/ChangeButton/index": 976,
	"./components/ChangeButton/index.tsx": 976,
	"./components/SettingToggler": 914,
	"./components/SettingToggler/": 914,
	"./components/SettingToggler/SettingToggler.module.scss": 1032,
	"./components/SettingToggler/index": 914,
	"./components/SettingToggler/index.tsx": 914,
	"./components/SettingsSection": 858,
	"./components/SettingsSection/": 858,
	"./components/SettingsSection/SettingsSection.module.scss": 929,
	"./components/SettingsSection/index": 858,
	"./components/SettingsSection/index.tsx": 858,
	"./components/ThemeSetting": 974,
	"./components/ThemeSetting/": 974,
	"./components/ThemeSetting/ThemeSetting": 975,
	"./components/ThemeSetting/ThemeSetting.dictionary": 931,
	"./components/ThemeSetting/ThemeSetting.dictionary.json": 931,
	"./components/ThemeSetting/ThemeSetting.explanation": 1136,
	"./components/ThemeSetting/ThemeSetting.explanation.ts": 1136,
	"./components/ThemeSetting/ThemeSetting.module.scss": 1031,
	"./components/ThemeSetting/ThemeSetting.tsx": 975,
	"./components/ThemeSetting/components/ThemeCardWrapper": 903,
	"./components/ThemeSetting/components/ThemeCardWrapper/": 903,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper": 877,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.module.scss": 930,
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.tsx": 877,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard": 859,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/": 859,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard": 843,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.module.scss": 878,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.tsx": 843,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem": 844,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/": 844,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem": 833,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.module.scss": 848,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.tsx": 833,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index": 844,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index.ts": 844,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index": 859,
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index.ts": 859,
	"./components/ThemeSetting/components/ThemeCardWrapper/index": 903,
	"./components/ThemeSetting/components/ThemeCardWrapper/index.ts": 903,
	"./components/ThemeSetting/index": 974,
	"./components/ThemeSetting/index.ts": 974,
	"./components/UserSecuritySettings": 1008,
	"./components/UserSecuritySettings/": 1008,
	"./components/UserSecuritySettings/ModalBody": 933,
	"./components/UserSecuritySettings/ModalBody/": 933,
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary": 977,
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary.json": 977,
	"./components/UserSecuritySettings/ModalBody/index": 933,
	"./components/UserSecuritySettings/ModalBody/index.tsx": 933,
	"./components/UserSecuritySettings/ModalFooter": 1034,
	"./components/UserSecuritySettings/ModalFooter.tsx": 1034,
	"./components/UserSecuritySettings/ModalResponseError": 904,
	"./components/UserSecuritySettings/ModalResponseError/": 904,
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary": 934,
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary.json": 934,
	"./components/UserSecuritySettings/ModalResponseError/index": 904,
	"./components/UserSecuritySettings/ModalResponseError/index.tsx": 904,
	"./components/UserSecuritySettings/PasswordModal": 1064,
	"./components/UserSecuritySettings/PasswordModal.tsx": 1064,
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary": 849,
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary.json": 849,
	"./components/UserSecuritySettings/UserSecuritySettings.module.scss": 850,
	"./components/UserSecuritySettings/changePassword": 932,
	"./components/UserSecuritySettings/changePassword.ts": 932,
	"./components/UserSecuritySettings/constants": 1033,
	"./components/UserSecuritySettings/constants.ts": 1033,
	"./components/UserSecuritySettings/index": 1008,
	"./components/UserSecuritySettings/index.tsx": 1008,
	"./components/UserSecuritySettings/password-form-validation": 1035,
	"./components/UserSecuritySettings/password-form-validation.ts": 1035,
	"./components/UserStakeSettings": 978,
	"./components/UserStakeSettings/": 978,
	"./components/UserStakeSettings/UserStakeSettings.dictionary": 1036,
	"./components/UserStakeSettings/UserStakeSettings.dictionary.json": 1036,
	"./components/UserStakeSettings/index": 978,
	"./components/UserStakeSettings/index.tsx": 978,
	"./index": 304,
	"./index.tsx": 304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1255;
module.exports = webpackContext;